var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7497DB3D-A057-4CF9-B449-37790BCFD889@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donor-Portal---Alt",
    transform: "translate(-1139.000000, -929.000000)",
    fill: "#2774AE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(968.000000, 660.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(171.000000, 269.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875,0 L1.125,0 C0.504,0 0,0.516923077 0,1.15384615 L0,13.8461538 C0,14.4836501 0.504,15 1.125,15 L16.875,15 C17.4965588,15 18,14.4836501 18,13.8461538 L18,1.15384615 C18,0.516923077 17.4965588,0 16.875,0 Z M16,13 L2,13 L2,5 L8.30753142,10.1402187 C8.50838813,10.3033668 8.75446154,10.385474 9,10.385474 C9.2460734,10.385474 9.49161187,10.3033668 9.69246858,10.1402187 L16,5 L16,13 Z M16,2.46993458 L9,9 L2,2.46993458 L2,2 L16,2 L16,2.46993458 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/ContactEmail.872131e2b2cdd72d5d46cadae4ef3adb.svg";
export { ForwardRef as ReactComponent };